// components/Modals/CancelSubscriptionModal.jsx
import React from "react";
import BaseModal from "./BaseModal";
import { X } from "lucide-react";

const CancelSubscriptionModal = ({ open, onClose, onConfirm }) => {
  return (
    <BaseModal open={open} onClose={onClose}>
      <div className="p-6 text-center space-y-4">
        <div className="mx-auto h-14 w-14 rounded-full bg-[#FFEFEB] flex items-center justify-center">
          <X className="text-[#FF6943]" size={28} />
        </div>

        <h2 className="text-[#FF6943] font-semibold">
          Cancel Subscription
        </h2>

        <p className="text-sm text-gray-500">
          Are you sure you want to cancel this subscription?
        </p>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 py-2 rounded-full border border-[#FF6943] text-[#FF6943]"
          >
            Go Back
          </button>

          <button
            onClick={onConfirm}
            className="flex-1 py-2 rounded-full bg-[#FF6943] text-white"
          >
            Yes, Cancel
          </button>
        </div>
      </div>
    </BaseModal>
  );
};

export default CancelSubscriptionModal;
